module.exports = __webpack_public_path__ + "static/img/drop.8efdb5de.png";